export const Footer = () => {
  return (
    <footer className="cream-bg border-t border-border py-12 relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center">
          <p className="font-sans text-xs tracking-widest text-muted-foreground mb-2">
            POLINA & EVGENIY
          </p>
          <p className="font-sans text-xs tracking-wide text-muted-foreground">
            September 7, 2026 · Talici Hill, Montenegro
          </p>
        </div>
      </div>
    </footer>
  );
};
